<template>
  <div>
    <Form ref="dataDetails" :model="dataDetails" :label-width="140" disabled>
      <Card style="margin-bottom: 10px">
        <span slot="title"> {{ $t("Transport info") }} </span>
        <Row :gutter="10" style="padding-top: 10px; margin: -16px">
          <Col span="6">
            <FormItem :label="$t('dingcangCompany')">
              <Select
                v-model="dataDetails.dingcang_company"
                filterable
                filter-by-label
                :placeholder="$t('select') + $t('dingcangCompany')"
              >
                <Option
                  class="company-class"
                  v-for="item in otherObj.ding"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.code }} - {{ item.alias }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('transport_method')">
              <Input v-model="dataDetails.shipment.transport_code_txt"> </Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('company')">
              <Input v-model="dataDetails.shipment.consignee"> </Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('allow_depart')">
              <Input v-model="dataDetails.shipment.from_country"> </Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('allow_arrive')">
              <Input v-model="dataDetails.shipment.to_country"> </Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('is_solely')">
              <RadioGroup v-model="dataDetails.is_solely">
                <Radio :label="dataDetails.is_solely" border>
                  {{ $t(dataDetails.is_solely) }}
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col v-if="dataDetails.is_solely === 'YES'" span="6">
            <FormItem :label="$t('Document Set')">
              <Input
                v-model="dataDetails.documents"
                placeholder="Please Enter dan_zheng_nums"
              >
              </Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('warehouseName')" prop="cangku">
              <Input v-model="dataDetails.shipment.warehouse" disabled></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('CODCurrency')">
              <Select
                v-model="dataDetails.cod_currency"
                :placeholder="$t('CODCurrency')"
              >
                <Option
                  v-for="item in currencyList"
                  :value="item.code"
                  :key="item.code"
                  :label="item.title + '(' + item.code + ')'"
                ></Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('CODAmount')">
              <InputNumber
                v-model="dataDetails.cod_amount"
                v-bind="{
                  step: 0.01,
                  min: 0,
                  style: 'width:100%',
                }"
              ></InputNumber>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('distribution_agent')">
              <Select
                v-model="dataDetails.delivery_agent_id"
                filterable
                filter-by-label
                placeholder=""
              >
                <Option
                  class="company-class"
                  v-for="item in deliveryList"
                  :value="item.value"
                  :key="item.value"
                  :label="item.label"
                ></Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('city_name')">
              <InputNumber
                v-model="dataDetails.shipment.city_name"
                v-bind="{
                  step: 0.01,
                  min: 0,
                  style: 'width:100%',
                }"
              ></InputNumber>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem :label="$tz('客服,备注')" prop="cs_remarks">
              <Input
                type="textarea"
                :rows="2"
                v-model="dataDetails.cs_remarks"
                disabled
              ></Input>
            </FormItem>
          </Col>

          <Col span="12">
            <FormItem :label="$t('address')" prop="address">
              <Input
                type="textarea"
                :rows="2"
                v-model="dataDetails.shipment.consignee_address"
                disabled
              ></Input>
            </FormItem>
          </Col>
        </Row>
      </Card>
      <div class="table-header">{{ $t("Goods Info") }}</div>
      <Table
        height="150"
        :data="dataDetails.goods"
        :columns="tableTitle"
        border
        stripe
        style="margin-bottom: 10px"
      >
      </Table>
      <Card style="margin-bottom: 10px">
        <span slot="title"> {{ $t("Other Info") }} </span>
        <Row :gutter="10" style="padding-top: 10px; margin: -16px">
          <Col span="8">
            <FormItem :label="$t('baoguan')">
              <Select
                v-model="dataDetails.baoguan_type"
                filterable
                :placeholder="$t('select') + $t('baoguan')"
              >
                <Option
                  class="company-class"
                  v-for="item in otherObj.baoguan_type"
                  :value="item.id"
                  :key="item.id"
                  :label="item.name"
                ></Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('Document Set')">
              <Input v-model="dataDetails.dan_zheng_nums"> </Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('next_page')">
              <Input v-model="dataDetails.xu_page"> </Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('safetyService')">
              <RadioGroup v-model="dataDetails.is_safe">
                <Radio :label="1" border>{{ $t("YES") }}</Radio>
                <Radio :label="0" border>{{ $t("NO") }}</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('safetyServicePlan')">
              <Input v-model="dataDetails.safe_plan_name"> </Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('DeclaredValue') + '（USD）'">
              <Input v-model="dataDetails.values"> </Input>
            </FormItem>
          </Col>
        </Row>
      </Card>
    </Form>
    <div class="table-header">
      {{ $t("valueServiceInfo") }}
      <!-- <Button
        v-if="$hasPermission(1152)"
        style="margin-left: 10px"
        type="error"
        @click="deleteClick"
        icon="md-trash"
        :disabled="!selectArr.length"
      >
        {{ $t("delete") }}
      </Button> -->
    </div>
    <Table
      height="150"
      ref="selection"
      :data="serverList"
      :columns="valueServer"
      border
      stripe
      style="margin-bottom: 10px"
      @on-selection-change="selectTable"
    >
    </Table>
    <div class="table-header">
      {{ $t("special_remark") }}
      <!-- <Button
		    v-if="$hasPermission(1152)"
		    style="margin-left: 10px"
		    type="error"
		    @click="deleteClick"
		    icon="md-trash"
		    :disabled="!selectArr.length"
		  >
		    {{ $t("delete") }}
		  </Button> -->
    </div>
    <Table
      height="150"
      ref="selection"
      :data="remarkList"
      :columns="valueRemark"
      border
      stripe
      style="margin-bottom: 10px"
    >
    </Table>
  </div>
</template>
<script>
import {
  getContacts,
  getDoubleInfo,
  getServiceDetail,
  getRemarkDetail,
  deleteService,
} from "@/api/double/list";
import { getTransportAgent } from "@/api/tracker/air";
import { getCountryCategory } from "@/api/storage/category";
import { getCurrency } from "@/api/finance/cod_rate";
export default {
  inject: ["$page"],
  props: {
    row: {
      type: Object,
    },
    close: {
      type: Function,
    },
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("category"),
        align: "center",
        tooltip: true,
        key: "goods_name",
        width: 120,
      });
      columns.push({
        title: this.$t("Carton No."),
        key: "box_number_remarks",
        align: "center",
        tooltip: true,
        width: 95,
      });
      columns.push({
        key: "pieces_num",
        align: "center",
        tooltip: true,
        width: 85,
        renderHeader: (h) => {
          var text = this.$t("CTNS");
          return h("span", {
            domProps: {
              innerHTML: text,
            },
          });
        },
      });
      columns.push({
        key: "weight",
        align: "center",
        tooltip: true,
        width: 85,
        renderHeader: (h) => {
          var text = this.$t("doubleweight") + "<br/>(KG)";
          return h("span", {
            domProps: {
              innerHTML: text,
            },
          });
        },
      });
      columns.push({
        title: this.$t("skuVolume") + "\r\n(CBM)",
        key: "volume",
        align: "center",
        width: 85,
        tooltip: true,
        renderHeader: (h) => {
          var text = this.$t("skuVolume") + "<br/>(CBM)";
          return h("span", {
            domProps: {
              innerHTML: text,
            },
          });
        },
      });
      columns.push({
        key: "charging_weight",
        align: "center",
        tooltip: true,
        width: 100,
        renderHeader: (h) => {
          var text = this.$t("charge_params") + "<br/>(KG)";
          return h("span", {
            domProps: {
              innerHTML: text,
            },
          });
        },
      });
      columns.push({
        key: "charging_volume",
        align: "center",
        tooltip: true,
        width: 100,
        renderHeader: (h) => {
          var text = this.$t("charging_volume") + "<br/>(CBM)";
          return h("span", {
            domProps: {
              innerHTML: text,
            },
          });
        },
        dissbled: true,
      });
      columns.push({
        key: "volume_weight",
        align: "center",
        tooltip: true,
        width: 100,
        renderHeader: (h) => {
          var text = this.$t("charge_volume") + "<br/>(KG)";
          return h("span", {
            domProps: {
              innerHTML: text,
            },
          });
        },
      });
      columns.push({
        title: this.$t("battery"),
        key: "charged",
        align: "center",
        width: 100,
        render: (h, { row }) => {
          return h("span", this.$t(row.charged == 1 ? "YES" : "NO"));
        },
      });
      columns.push({
        title: this.$t("valueService"),
        key: "add_services",
        align: "center",
        width: 150,
        render: (h, { row }) => {
          return h("span", row.add_services.join());
        },
      });
      columns.push({
        title: this.$t("quantity_num"),
        key: "nums",
        align: "center",
        width: 80,
      });
      columns.push({
        title: this.$t("Other Remark"),
        key: "remarks",
        align: "center",
        minWidth: 100,
        tooltip: true,
      });
      columns.push({
        title: this.$t("operate"),
        key: "create_name",
        align: "center",
        width: 80,
        tooltip: true,
      });
      columns.push({
        title: this.$t("operation time"),
        key: "create_time",
        align: "center",
        width: 170,
      });
      return columns;
    },
    valueRemark() {
      let columns = [];
      columns.push({
        title: this.$t("Remarks"),
        align: "center",
        tooltip: true,
        key: "remarks",
        minWidth: 120,
      });
      columns.push({
        title: this.$t("operate"),
        align: "center",
        tooltip: true,
        key: "create_name",
        minWidth: 120,
      });
      columns.push({
        title: this.$t("operation") + this.$t("time"),
        align: "center",
        tooltip: true,
        key: "create_time",
        minWidth: 120,
      });
      columns.push({
        title: this.$t("img") + " 1",
        align: "center",
        tooltip: true,
        key: "src1",
        render: (h, p) => {
          if (!p.row.src1) return;
          return h("img", {
            attrs: { src: this.$globalUrl + p.row.src1, height: 30 },
            on: {
              click: () => {
                window.open(this.$globalUrl + p.row.src1);
              },
            },
          });
          // return h('Button',{attrs:{type:'primary',size:'small',}},this.$t('show'))
        },
        width: 100,
      });
      columns.push({
        title: this.$t("img") + " 2",
        align: "center",
        tooltip: true,
        key: "src2",
        render: (h, p) => {
          if (!p.row.src2) return;
          return h("img", {
            attrs: { src: this.$globalUrl + p.row.src2, height: 30 },
            on: {
              click: () => {
                window.open(this.$globalUrl + p.row.src2);
              },
            },
          });
          // return h('Button',{attrs:{type:'primary',size:'small',}},this.$t('show'))
        },
        width: 100,
      });
      return columns;
    },
    valueServer() {
      let columns = [];
      columns.push({
        type: "selection",
        width: 60,
        align: "center",
      });
      columns.push({
        title: this.$t("valueService") + this.$t("alipay_name"),
        align: "center",
        tooltip: true,
        key: "service_name",
        minWidth: 120,
      });
      columns.push({
        title: this.$t("Billing") + this.$t("noofpieces"),
        align: "center",
        tooltip: true,
        key: "quantity",
        minWidth: 120,
      });
      // columns.push({
      //   title: this.$t("valueService") + this.$t("cost_t"),
      //   align: "center",
      //   tooltip: true,
      //   key: "total_amount",
      //   minWidth: 120,
      // });
      columns.push({
        title: this.$t("operate"),
        align: "center",
        tooltip: true,
        key: "create_name",
        minWidth: 120,
      });
      columns.push({
        title: this.$t("operation") + this.$t("time"),
        align: "center",
        tooltip: true,
        key: "create_time",
        minWidth: 120,
      });
      return columns;
    },
  },
  data() {
    return {
      remarkList: [],
      currencyList: [],
      cateList: [],
      otherObj: {},
      serverList: [],
      selectArr: [],
      deliveryList: [],
      dataDetails: {
        dingcang_company: "",
        baoguan_type: "",
        xu_page: "",
        dan_zheng_nums: "",
        is_safe: "",
        remarks: "",
        values: "",
        shipment: {
          transport_code_txt: "",
          consignee: "",
          from_country: "",
          to_country: "",
        },
      },
      preForm: {},
      unChange: true,
      // ruleFrom: {
      //   dingcang_company: [
      //     {
      //       required: true,
      //       type: "number",
      //       message: "cannot be empty",
      //       trigger: "change"
      //     }
      //   ],
      //   airline: [
      //     {
      //       required: true,
      //       type: "number",
      //       message: "cannot be empty",
      //       trigger: "change"
      //     }
      //   ],
      //   cangku: [
      //     {
      //       required: true,
      //       type: "number",
      //       message: "cannot be empty",
      //       trigger: "change"
      //     }
      //   ],
      //   start_gang: [
      //     {
      //       required: true,
      //       type: "number",
      //       message: "cannot be empty",
      //       trigger: "change"
      //     }
      //   ],
      //   middle_gang: [
      //     {
      //       required: true,
      //       type: "number",
      //       message: "cannot be empty",
      //       trigger: "change"
      //     }
      //   ],
      //   end_gang: [
      //     {
      //       required: true,
      //       type: "number",
      //       message: "cannot be empty",
      //       trigger: "change"
      //     }
      //   ],
      //   maitou: [{}],
      //   weight: [{ required: true, validator: minNum, trigger: "blur" }],
      //   volume: [{ required: true, validator: minNum, trigger: "blur" }],
      //   charging_volume: [
      //     { required: true, validator: minNum, trigger: "blur" }
      //   ],
      //   charging_weight: [
      //     { required: true, validator: minNum, trigger: "blur" }
      //   ],
      //   dangzheng_user: [{}],
      //   shipping_terms: [
      //     {
      //       required: true,
      //       type: "number",
      //       message: "cannot be empty",
      //       trigger: "change"
      //     }
      //   ],
      //   tuoyun_user: [{}],
      //   fee_terms: [
      //     {
      //       required: true,
      //       type: "number",
      //       message: "cannot be empty",
      //       trigger: "change"
      //     }
      //   ],
      //   baoguan_type: [
      //     {
      //       required: true,
      //       type: "number",
      //       message: "cannot be empty",
      //       trigger: "change"
      //     }
      //   ],
      //   kong_fee: [{}],
      //   fangdan_type: [
      //     {
      //       required: true,
      //       type: "number",
      //       message: "cannot be empty",
      //       trigger: "change"
      //     }
      //   ]
      // }
    };
  },
  methods: {
    alertMes(res) {
      if (res.data.status) {
        this.$Message["success"]({
          background: true,
          content: res.data.msg,
        });
      } else {
        this.$Message["error"]({
          background: true,
          content: res.data.msg,
          duration: 5,
        });
      }
    },
    selectTable(val) {
      this.selectArr = [];
      val.some((item) => {
        this.selectArr.push(item.id);
      });
    },
    deleteClick() {
      this.$Modal.confirm({
        title: this.$t("delete"),
        width: 300,
        content: this.$t("titleModal"),
        onOk: () => {
          deleteService(this.row.airway_number, {
            id: this.selectArr,
            target_type: this.row.target_type,
          }).then((res) => {
            this.alertMes(res);
            this.getValueServer();
          });
        },
      });
    },
    getValueServer() {
      getServiceDetail(this.row.airway_number).then((res) => {
        this.serverList = res.data.payload;
      });
    },
    init() {
      getRemarkDetail(this.row.airway_number).then((res) => {
        this.remarkList = res.data.payload;
      });
    },
  },
  mounted() {
    getTransportAgent().then((res) => {
      this.deliveryList = res.data.payload;
    });
    getCurrency().then((res) => {
      this.currencyList = res.data.payload;
    });
    getContacts().then((res) => {
      this.otherObj = res.data.payload;
    });
    getDoubleInfo(this.row.airway_number).then((res) => {
      if (res.data.status) {
        this.dataDetails = res.data.payload;
      }
      getCountryCategory({
        country: this.dataDetails.shipment.to_country,
      }).then((res) => {
        this.cateList = res.data.payload;
      });
    });
    this.getValueServer();
    this.init();
  },
};
</script>

<style lang="less" scoped>
.ivu-form-item {
  margin-bottom: 10px;
}
.table-header {
  border: 1px solid #e8eaec;
  border-bottom: 0;
  padding: 14px 16px;
  line-height: 1;
}
</style>
